export const graphOptions = themeContext => {
  return {
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'top',
      fullWidth: true,
      reverse: false,
      labels: {
        fontColor: themeContext?.fontColor,
        fontSize: 12,
      },
    },

    animation: {
      duration: 3000,
      easing: 'easeOutQuart',
      onComplete: function() {
        const chart = this.chart;
        const ctx = chart.ctx;

        ctx.font = Chart.helpers.fontString(
          18,
          'bold',
          Chart.defaults.global.defaultFontFamily,
        );

        ctx.fillStyle = themeContext?.fontColor || '#000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';

        this.data.datasets.forEach(function(dataset, i) {
          const meta = chart.controller.getDatasetMeta(i);

          meta.data.forEach(function(bar, index) {
            const value = dataset.data[index];

            ctx.fillText(value, bar._model.x, bar._model.y - 5);
          });
        });
      },
    },

    tooltips: {
      backgroundColor: '#f5f5f5',
      titleFontColor: '#333',
      titleFontSize: 15,
      titleFontStyle: 'bold',
      bodyFontColor: '#666',
      bodySpacing: 4,
      xPadding: 12,
      mode: 'nearest',
      intersect: 0,
      position: 'nearest',
      bodyFontSize: 15,
      bodyFontStyle: 'bold',
    },

    hover: {
      mode: null,
      animationDuration: 0,
    },

    responsive: true,

    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: themeContext?.graph.graphAxis,
            zeroLineColor: 'transparent',
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax: 10,
            padding: 10,
            fontColor: themeContext?.fontColor,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: themeContext?.graph.graphAxis,
            zeroLineColor: 'transparent',
          },
          ticks: {
            padding: 5,
            fontColor: themeContext?.fontColor,
            fontSize: 14,
          },
        },
      ],
    },
  };
};
